export class SimpleSubject {
    constructor() {
        this.observers = [];
        this.closed = false;
    }
    subscribe(observer) {
        if (this.closed) {
            return { unsubscribe: () => { } };
        }
        const obs = typeof observer === "function" ? { next: observer } : observer;
        this.observers.push(obs);
        return {
            unsubscribe: () => {
                const index = this.observers.indexOf(obs);
                if (index > -1) {
                    this.observers.splice(index, 1);
                }
            }
        };
    }
    next(value) {
        if (this.closed)
            return;
        this.observers.forEach(observer => {
            try {
                observer.next(value);
            }
            catch (error) {
                if (observer.error) {
                    observer.error(error);
                }
                else {
                    console.error("Error in observer:", error);
                }
            }
        });
    }
    error(error) {
        if (this.closed)
            return;
        this.observers.forEach(observer => {
            if (observer.error) {
                observer.error(error);
            }
        });
        this.complete();
    }
    complete() {
        if (this.closed)
            return;
        this.observers.forEach(observer => {
            if (observer.complete) {
                observer.complete();
            }
        });
        this.observers = [];
        this.closed = true;
    }
}
export class SimpleBehaviorSubject extends SimpleSubject {
    constructor(_value) {
        super();
        this._value = _value;
    }
    get value() {
        return this._value;
    }
    next(value) {
        this._value = value;
        super.next(value);
    }
    subscribe(observer) {
        const subscription = super.subscribe(observer);
        // Emit current value immediately
        const obs = typeof observer === "function" ? { next: observer } : observer;
        try {
            obs.next(this._value);
        }
        catch (error) {
            if (obs.error) {
                obs.error(error);
            }
            else {
                console.error("Error in observer:", error);
            }
        }
        return subscription;
    }
}
